export default __webpack_public_path__ + "static/media/steering-wheel.fdb652d9.svg";